import axios from 'axios';
import { refreshAccessToken } from "./apiClient";
import {API_URL} from './constant';

//getting pre-signed url for upload
export async function getPreUrl(data) {
    try{
        console.log("📤 Sending request to get pre-signed URL:", data);
        const accessToken  = localStorage.getItem('accessToken');
        const parsedToken = JSON.parse(accessToken);

        const response = await fetch(`${API_URL}/generate_presigned_url/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${parsedToken}`,
            },
            body: JSON.stringify(data),
            });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        console.log("✅ Received response from server:", responseData);

        return responseData;

    }catch(error){
        console.log("Error while getting presigned url",error.response?.data || error.message);
        throw error;
    }
}


// create users
// export async function createUsers(payload) {
//     try{
//         console.log("data on apiUsers",payload)
        
//         // token
//         const accessToken = localStorage.getItem('accessToken');
//         const parsedToken = JSON.parse(accessToken)

//     const response = await fetch(`${API_URL}/users/?orgId=${payload.org}`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${parsedToken}`,
//         },
//         body: JSON.stringify(payload)
//         });

//     const userResponse = await response.json();
    
//     if (!response.ok) {
//             const err = new Error('User creation failed');
//             err.data = userResponse;
//             err.status = response.status;
//             throw err;
//         }

//     if(payload.role === '00000000-0000-0000-0000-000000000004'){
//         const appraiserData = {
//             user:userResponse.user_id,
//             org: payload.org,
//             license: payload.license,
//             expiry_date: payload.expiry_date,
//             appraiser_sign_path: payload.appraiser_sign_path,
//             appraiser_cert_path: payload.appraiser_cert_path
//         };

//         const appraiserResponse = await fetch(`${API_URL}/appraisers/`,{
//             method:'POST',
//             headers:{
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${parsedToken}`
//             },
//             body:JSON.stringify(appraiserData)
//         });

//         const appraiserDataRes = await appraiserResponse.json();

//         if (!appraiserResponse.ok) {
//                 const err = new Error('Appraiser creation failed');
//                 err.data = appraiserDataRes;
//                 err.status = appraiserResponse.status;
//                 throw err;
//             }
//     }

//     return userResponse;

//     }catch(error){
//         console.log("Error while creating the user",error?.data || error.message);
//         throw error;
//     }
// }

// new one
// export async function createUsers(payload) {
//     const accessToken = localStorage.getItem('accessToken');
//     if (!accessToken) throw new Error("Access token is missing");

//     const parsedToken = JSON.parse(accessToken);
//     const headers = {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${parsedToken}`,
//     };

//     try {
//         // Create user
//         const userResponse = await fetch(`${API_URL}/users/?orgId=${payload.org}`, {
//             method: 'POST',
//             headers,
//             body: JSON.stringify(payload),
//         });

//         const userData = await userResponse.json();

//         if (!userResponse.ok) {
//             const err = new Error('User creation failed');
//             err.data = userData;
//             err.status = userResponse.status;
//             throw err;
//         }

//         // If role is Appraiser, create related appraiser entry
//         if (payload.role === '00000000-0000-0000-0000-000000000004') {
//             const appraiserPayload = {
//                 user: userData.user_id,
//                 org: payload.org,
//                 license: payload.license,
//                 expiry_date: payload.expiry_date,
//                 appraiser_sign_path: payload.appraiser_sign_path,
//                 appraiser_cert_path: payload.appraiser_cert_path,
//             };

//             const appraiserResponse = await fetch(`${API_URL}/appraisers/`, {
//                 method: 'POST',
//                 headers,
//                 body: JSON.stringify(appraiserPayload),
//             });

//             const appraiserData = await appraiserResponse.json();

//             if (!appraiserResponse.ok) {
//                 const err = new Error('Appraiser creation failed');
//                 err.data = appraiserData;
//                 err.status = appraiserResponse.status;
//                 throw err;
//             }
//         }

//         return userData;

//     } catch (error) {
//         console.error("Error while creating the user:", error?.data || error.message || error);
//         throw error;
//     }
// }

export async function createUsers(payload) {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) throw new Error("Access token is missing");

    const parsedToken = JSON.parse(accessToken);

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${parsedToken}`,
    };

    try {
        const response = await fetch(
            `${API_URL}/users/?orgId=${payload.org}`,
            {
                method: "POST",
                headers,
                body: JSON.stringify(payload),
            }
        );

        const data = await response.json();

        if (!response.ok) {
            const err = new Error("User creation failed");
            err.data = data;
            err.status = response.status;
            throw err;
        }

        return data;
    } catch (error) {
        console.error(
            "Error while creating user:",
            error?.data || error.message || error
        );
        throw error;
    }
}

// new one
// user list
// export async function userList(page=1,page_size=10,searchTerm,orgFilter) {
//     try{
//         const parsedToken = JSON.parse((localStorage.getItem('accessToken')))

//         const params = new URLSearchParams({
//           page,
//           page_size: page_size
//         })

//         if (orgFilter) params.append('org',orgFilter);
//         if (searchTerm) params.append('search', searchTerm);

//         // const response = await fetch(`${API_URL}/users/?page=${page}&page_size=${page_size}`,{
//         //     method:'GET',
//         //     headers:{
//         //         'Content-Type':'application/json',
//         //         'Authorization': `Bearer ${parsedToken}`
//         //     }
//         // })

//         const response = await fetch(`${API_URL}/users/?${params.toString()}`,{
//           method: 'GET',
//           headers: {
//             'Content-Type' : 'application/json',
//             'Authorization' : `Bearer ${parsedToken}`,
//           }
//         })

//         const usersData = await response.json();

//         if(!response.ok){
//             const err = new Error('Fetching users failed');
//                 err.data = usersData;
//                 err.status = response.status;
//                 throw err;
//         }

//         // const appraiserResponse = await fetch(`${API_URL}/appraisers/?page=${page}&page_size=${page_size}`,{
//         //     method:'GET',
//         //     headers:{
//         //         'Content-Type':'application/json',
//         //         'Authorization': `Bearer ${parsedToken}`
//         //     }
//         // })
//         const appraiserResponse = await fetch(`${API_URL}/appraisers/?${params.toString()}`,{
//             method:'GET',
//             headers:{
//                 'Content-Type':'application/json',
//                 'Authorization': `Bearer ${parsedToken}`
//             }
//         })

//         const appraisersData = await appraiserResponse.json();

//         console.log("appraisers",appraisersData)
//         if(!appraiserResponse.ok){
//             const err = new Error('Fetching appraisers failed');
//             err.data = appraisersData;
//             err.status = appraiserResponse.status;
//             throw err;
//         }

//         const users =usersData.results;
//         const appraisers = appraisersData.results;

//         // merging the both data according to the user_id
//         const mergedData = users.map((user)=>{
//             const appraiser = appraisers.find((a)=>{
//                 return a.user === user.user_id
//             });

//             return appraiser ? {...user, ...appraiser} : user;
//         })
//         console.log("merged data on api",mergedData)
//         return {
//             results: mergedData,
//             count: usersData.count,
//             next: usersData.next,
//             previous: usersData.previous
//         };

//     }catch(error){
//         console.log("Error while getting the user list",error?.data || error.message);
//         throw error;
//     }
// }

// export async function userList(page = 1, page_size = 10) {
//   const token = localStorage.getItem("accessToken");
//   if (!token) throw new Error("Access token is missing");

//   const parsedToken = JSON.parse(token);
//   const headers = {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${parsedToken}`,
//   };

//   const buildUrl = (endpoint) =>
//     `${API_URL}/${endpoint}/?page=${page}&page_size=${page_size}`;

//   const fetchWithCheck = async (url, entityName) => {
//     const res = await fetch(url, { method: "GET", headers });
//     const data = await res.json();
//     if (!res.ok) {
//       const err = new Error(`Fetching ${entityName} failed`);
//       err.data = data;
//       err.status = res.status;
//       throw err;
//     }
//     return data;
//   };

//   try {
//     const [usersData, appraisersData] = await Promise.all([
//       fetchWithCheck(buildUrl("users"), "users"),
//       fetchWithCheck(buildUrl("appraisers"), "appraisers"),
//     ]);

//     const appraiserMap = new Map(
//       appraisersData.results.map((a) => [a.user, a])
//     );

//     const mergedData = usersData.results.map((user) => {
//       const appraiser = appraiserMap.get(user.user_id);
//       return appraiser ? { ...user, ...appraiser } : user;
//     });

//     return {
//       results: mergedData,
//       count: usersData.count,
//       next: usersData.next,
//       previous: usersData.previous,
//     };
//   } catch (error) {
//     console.error(
//       "Error while getting the user list:",
//       error?.data || error.message || error
//     );
//     throw error;
//   }
// }

export async function userList(
    page = 1,
    page_size = 10,
    searchTerm,
    orgFilter
) {
    try {
        const parsedToken = JSON.parse(localStorage.getItem("accessToken"));

        const params = new URLSearchParams({
            page,
            page_size,
        });

        if (orgFilter) params.append("org", orgFilter);
        if (searchTerm) params.append("search", searchTerm);

        const response = await fetch(
            `${API_URL}/users/?${params.toString()}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${parsedToken}`,
                },
            }
        );

        const usersData = await response.json();

        if (!response.ok) {
            const err = new Error("Fetching users failed");
            err.data = usersData;
            err.status = response.status;
            throw err;
        }

        return usersData;
    } catch (error) {
        console.log(
            "Error while getting the user list",
            error?.data || error.message
        );
        throw error;
    }
}

// edit users
// export async function editUsers(data) {
//   try {
//     const parsedToken = JSON.parse(localStorage.getItem("accessToken"));

//     // Construct only non-null fields for PATCH
//     const userUpdateData = {};
//     if (data.firstname) userUpdateData.first_name = data.firstname;
//     if (data.lastname) userUpdateData.last_name = data.lastname;
//     if (data.email) userUpdateData.email_id = data.email;
//     if (data.phonenumber) userUpdateData.phone_number = data.phonenumber;
//     if (data.state) userUpdateData.state = data.state;
//     if (data.role) userUpdateData.role = data.role;
//     if (data.org) userUpdateData.org = data.org;

//     const response = await fetch(`${API_URL}/users/${data.user_id}/`, {
//       method: "PATCH",
//       headers: {
//         "Content-Type": "application/json",
//         'Authorization': `Bearer ${parsedToken}`,
//       },
//       body: JSON.stringify(userUpdateData),
//     });

//     const responseData = await response.json();

//     if (!response.ok) {
//       const err = new Error("Editing users failed");
//       err.data = responseData;
//       err.status = response.status;
//       throw err;
//     }

//     // Check if appraiser data needs updating
//     if (data.role === "00000000-0000-0000-0000-000000000004") {
//       const appraiserData = {};
//       appraiserData.user = data.user_id;
//       if (data.org) appraiserData.org = data.org;
//       if (data.license) appraiserData.license = data.license;
//       if (data.expirationdate) appraiserData.expiry_date = data.expirationdate;
//       if (data.appraisersignature) appraiserData.appraiser_sign_path = data.appraisersignature;
//       if (data.appraisercertificate) appraiserData.appraiser_cert_path = data.appraisercertificate;

//       const appraiserResponse = await fetch(`${API_URL}/appraisers/${data.user_id}/`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           'Authorization': `Bearer ${parsedToken}`,
//         },
//         body: JSON.stringify(appraiserData),
//       });

//       const appraiserDataRes = await appraiserResponse.json();

//       if (!appraiserResponse.ok) {
//         const err = new Error("Appraiser update failed");
//         err.data = appraiserDataRes;
//         err.status = appraiserResponse.status;
//         throw err;
//       } 
//     }

//     return responseData;
//   } catch (error) {
//     console.log("Error while editing the user data", error?.data || error.message);
//     throw error;
//   }
// }

// new one
// export async function editUsers(data) {
//   const parsedToken = JSON.parse(localStorage.getItem("accessToken"));
//   const headers = {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${parsedToken}`,
//   };

//   const buildPatchPayload = (fieldsMap) =>
//     Object.fromEntries(Object.entries(fieldsMap).filter(([_, v]) => v !== null && v !== undefined));

//   const sendPatchRequest = async (url, body, entityName) => {
//     const response = await fetch(url, {
//       method: "PATCH",
//       headers,
//       body: JSON.stringify(body),
//     });

//     const responseData = await response.json();

//     if (!response.ok) {
//       const err = new Error(`Editing ${entityName} failed`);
//       err.data = responseData;
//       err.status = response.status;
//       throw err;
//     }

//     return responseData;
//   };

//   try {
//     // Prepare user data
//     const userPayload = buildPatchPayload({
//       first_name: data.first_name,
//       last_name: data.last_name,
//       email_id: data.email_id,
//       phone_number: data.phone_number,
//       state: data.state,
//       role: data.role,
//       org: data.org,
//     });

//     const userRes = await sendPatchRequest(`${API_URL}/users/${data.user_id}/`, userPayload, "user");

//     // Handle appraiser update if role matches
//     if (data.role === "00000000-0000-0000-0000-000000000004") {
//       const appraiserPayload = buildPatchPayload({
//         user: data.user_id,
//         org: data.org,
//         license: data.license,
//         expiry_date: data.expirationdate,
//         appraiser_sign_path: data.appraisersignature,
//         appraiser_cert_path: data.appraisercertificate,
//       });

//       await sendPatchRequest(`${API_URL}/appraisers/${data.user_id}/`, appraiserPayload, "appraiser");
//     }

//     return userRes;
//   } catch (error) {
//     console.error("Error while editing the user data:", error?.data || error.message);
//     throw error;
//   }
// }

export async function editUsers(payload) {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) throw new Error("Access token is missing");

    const parsedToken = JSON.parse(accessToken);

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${parsedToken}`,
    };

    try {
        const response = await fetch(
            `${API_URL}/users/${payload.user_id}/?orgId=${payload.org}`,
            {
                method: "PATCH",
                headers,
                body: JSON.stringify(payload),
            }
        );

        const data = await response.json();

        if (!response.ok) {
            const err = new Error("User update failed");
            err.data = data;
            err.status = response.status;
            throw err;
        }

        return data;
    } catch (error) {
        console.error(
            "Error while updating user:",
            error?.data || error.message || error
        );
        throw error;
    }
}

// delete user
// export async function deleteUser(user) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'));

//         const response = await fetch(`${API_URL}/users/${user.user_id}/`,{
//             method:'DELETE',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })


//         if(!response.ok && response.status!== 204){
//             const errorData = await response.json();
//             const err = new Error("Deletion of user failed");
//             err.data = errorData;
//             err.status = response.status;
//             throw err;
//         }

//         if(user.role ==="00000000-0000-0000-0000-000000000004"){
//             const appraiserRes = await fetch(`${API_URL}/appraisers/${user.user_id}/`,{
//                 method:'DELETE',
//                 headers:{
//                     'Authorization': `Bearer ${parsedToken}`,
//                 }
//             })

//             if(!appraiserRes.ok && appraiserRes !== 204){
//                 const errorData = await appraiserRes.json();
//                 const err = new Error("Deletion of appraiser failed");
//                 err.data = errorData;
//                 err.status = appraiserRes.status;
//                 throw err;
//             }
//         }

//         return {success:true};
//     }catch(error){
//         console.log("Error while delete the user",error?.data || error.message);
//         throw error;
//     } 
// }

// // Helper to delete a specific entity
// async function attemptDeleteEntity(token, url, entityName) {
//   const response = await fetch(url, {
//     method: "DELETE",
//     headers: {
//       "Authorization": `Bearer ${token}`,
//     },
//   });

//   if (!response.ok && response.status !== 204) {
//     const errorData = await response.json();
//     const err = new Error(`Deletion of ${entityName} failed`);
//     err.data = errorData;
//     err.status = response.status;
//     throw err;
//   }
// }

// // Core function with retry logic
// export async function deleteUser(user) {
//   let accessToken = JSON.parse(localStorage.getItem("accessToken"));
//   const appraiserRoleId = "00000000-0000-0000-0000-000000000004";

//   const tryDeleteUser = async (token) => {
//     await attemptDeleteEntity(token, `${API_URL}/users/${user.user_id}/`, "user");

//     if (user.role === appraiserRoleId) {
//       await attemptDeleteEntity(token, `${API_URL}/appraisers/${user.user_id}/`, "appraiser");
//     }
//   };

//   try {
//     await tryDeleteUser(accessToken);
//     return { success: true };
//   } catch (error) {
//     if (error.status === 401) {
//       try {
//         const newAccessToken = await refreshAccessToken(); // assumes globally available
//         await tryDeleteUser(newAccessToken);
//         return { success: true };
//       } catch (refreshError) {
//         console.error("Token refresh failed:", refreshError.message);
//         throw refreshError;
//       }
//     }

//     console.error("Error while deleting the user:", error?.data || error.message);
//     throw error;
//   }
// }

// Helper to delete a specific entity
async function attemptDeleteEntity(token, url, entityName) {
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok && response.status !== 204) {
        const errorData = await response.json();

        const err = new Error(`Deletion of ${entityName} failed`);
        err.data = errorData;
        err.status = response.status;

        throw err;
    }
}

export async function deleteUser(user) {
    let accessToken = JSON.parse(localStorage.getItem("accessToken"));

    const tryDeleteUser = async (token) => {
        await attemptDeleteEntity(
            token,
            `${API_URL}/users/${user.user_id}/`,
            "user"
        );
    };

    try {
        await tryDeleteUser(accessToken);
        return { success: true };
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();

                await tryDeleteUser(newAccessToken);

                return { success: true };
            } catch (refreshError) {
                console.error(
                    "Token refresh failed:",
                    refreshError.message
                );
                throw refreshError;
            }
        }

        console.error(
            "Error while deleting the user:",
            error?.data || error.message
        );

        throw error;
    }
}

// update user status
// export async function statusUpdateUser(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/update_user_status/`,{
//             method:"POST",
//             headers:{
//                 "Content-Type": "application/json",
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json()

//         if(!response.ok){
//             const err = new Error("Updating Status failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("Error occurred while updating the status",error?.data ||  error.message)
//         throw error;
//     } 
// }

// Helper function to perform the API call
async function attemptStatusUpdateUser(token, data) {
  const response = await fetch(`${API_URL}/update_user_status/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Updating Status failed");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Exported function with token refresh retry
export async function statusUpdateUser(data) {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    return await attemptStatusUpdateUser(accessToken, data);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken(); // assumes globally available
        return await attemptStatusUpdateUser(newAccessToken, data);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError.message);
        throw refreshError;
      }
    }

    console.error("Error occurred while updating the status:", error?.data || error.message);
    throw error;
  }
}


// dash status
// export async function dashStatus() {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/dash_status/`,{
//             method:'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`
//             }
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Getting Dash Status failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("Error occurred while getting the dash status",error?.data ||  error.message)
//         throw error;
//     } 
// }

// Helper to attempt API call
async function attemptDashStatus(token) {
  const response = await fetch(`${API_URL}/dash_status/`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to fetch dashboard status");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main exported function
export async function dashStatus() {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    return await attemptDashStatus(accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptDashStatus(newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError.message);
        throw refreshError;
      }
    }

    console.error("Error occurred while getting dashboard status:", error?.data || error.message);
    throw error;
  }
}

// forget password no need of token
export async function passwordResetReq(data) {
  try{
    const response = await fetch(`${API_URL}/password-reset/request/`,{
      method:'POST',
      headers:{
        'Content-Type':"application/json"
      },
      body:JSON.stringify(data)
    })

    const responseData = await response.json();

    if (!response.ok) {
      const err = new Error("Password change request failed");
      err.data = responseData;
      err.status = response.status;
      throw err;
    }

    return responseData;
    
  }catch(error){
    console.error("Error occurred while requesting password change:", error?.data || error.message);
    throw error;
  }
}

// password confirm
export async function passwordConfirm(data) {
  try{
    const response = await fetch(`${API_URL}/password-reset/confirm/`,{
      method:'POST',
      headers:{
        'Content-Type':"application/json"
      },
      body:JSON.stringify(data)
    })

    const responseData = await response.json();
    
    if (!response.ok) {
      const err = new Error("Password confirmation failed");
      err.data = responseData;
      err.status = response.status;
      throw err;
    }

    return responseData;

  }catch(error){
    console.error("Error occurred while confirming password change:", error?.data || error.message);
    throw error;
  }
}